'use client';
import * as Sentry from '@sentry/nextjs';
import type { useTranslations } from 'next-intl';
import { toast } from '@/app/components/ui/use-toast';
import type { ServiceError } from '@/app/types';

/***
 * 统一处理部分服务端错误
 * @param error 服务端错误
 * @param intl 国际化
 */
export const handleServiceError = (error: ServiceError, t: ReturnType<typeof useTranslations<never>>) => {
  let msg = t('popup.toast.unknownError');
  switch (error.reason) {
    case 'TaskNotFound':
      msg = t('popup.toast.taskNotFound');
      break;
    case 'CreationNotFound':
      msg = t('popup.toast.creationNotFound');
      break;
    case 'SubscriptionNotFound':
      msg = t('popup.toast.subscriptionNotFound');
      break;
    case 'CommunityAuditTextFailed':
      msg = t('popup.toast.textUnPassed');
      break;
    case 'CommunityAuditImageFailed':
      msg = t('popup.toast.imgUnPassed');
      break;
    case 'CommunityAuditTIFailed':
      msg = t('popup.toast.textAndImgUnPassed');
      break;
    case 'InspirationCreateOverLimit':
      msg = t('popup.toast.submitCountLimit');
      break;
    case 'InspirationCreationIdNotFound':
      msg = t('popup.toast.inspirationNotFound');
      break;
    case 'InspirationCreationIdAlreadyUsed':
      msg = t('popup.toast.inspirationHadSubmitted');
      break;
    case 'UpdateOverLimit':
      msg = t('popup.toast.updateOverLimit');
      break;
    case 'ProfileUpdateClosed':
      msg = t('popup.toast.profileUpdateClosed');
      break;
    case 'AlreadySubmittedAudited':
      msg = t('personal.bio.auditing');
      break;
    case 'ActivityNotAllowSubmit':
      msg = t('popup.dialog.posts.error.activityNotAllowSubmit');
      break;
    case 'WorkDuplicateSubmission':
      msg = t('popup.dialog.posts.error.workDuplicateSubmission');
      break;
    case 'BattleSubmissionLimitExceeded':
      msg = '参赛投稿本日已达到上限，明天再来吧';
      break;
    case 'ForbiddenBetaTask':
    case 'ExperimentCreationTypeNotSupport':
      msg = t('popup.toast.forbiddenPost');
      break;
  }

  // 如果错误是未知错误，则上报到 Sentry
  if (msg === t('popup.toast.unknownError')) {
    Sentry.captureException(new Error('backend unknown error'), {
      tags: {
        'service.error_reason': error.reason,
        'service.error_message': error.message,
        'service.error_code': error.code,
      },
    });
  }

  toast({
    type: 'error',
    message: msg,
  });
};

// 处理 fetch 请求错误
export const getFetchErrorMsg = (error: Error, t: ReturnType<typeof useTranslations<never>>) => {
  if (
    error.message.toLowerCase().includes('network error') ||
    error.message.toLowerCase().includes('failed to fetch')
  ) {
    return t('popup.toast.networkError');
  }
  // 中断的错误
  if (error.name.toLowerCase().includes('aborterror')) {
    return t('popup.toast.abortError');
  }
  return t('popup.toast.systemError');
};
